import Axios from "axios";
import Swal from "sweetalert2";

export const token = () => {
  const match = document.cookie.match(/(?:^|;\s*)app_auth_token=([^;]*)/);
  return match ? match[1] : null;
};

export const config = () => {
  const matchToken = document.cookie.match(/(?:^|;\s*)app_auth_token=([^;]*)/);
  let token = matchToken ? matchToken[1] : null;
  const matchXsrf = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
  let xsrfToken = matchXsrf ? matchXsrf[1] : null;
  
  let headers = {
    Accept: "application/json",
  };

  if (token && token !== "null" && token !== "auth-session") {
    headers.Authorization = `Bearer ${token}`;
  }

  if (xsrfToken) {
    headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrfToken);
  }

  return {
    headers: headers,
  };
};
export const configBlob = () => {
  const matchToken = document.cookie.match(/(?:^|;\s*)app_auth_token=([^;]*)/);
  let token = matchToken ? matchToken[1] : null;
  const matchXsrf = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
  let xsrfToken = matchXsrf ? matchXsrf[1] : null;

  let headers = {
    Accept: "application/json",
  };

  if (token && token !== "null" && token !== "auth-session") {
    headers.Authorization = `Bearer ${token}`;
  }

  if (xsrfToken) {
    headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrfToken);
  }

  return {
    responseType: "blob",
    headers: headers,
  };
};
export const settings = () => {
  return {
    headers: {
      "Content-Type": "application/json",
    },
  };
};

const axios = Axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api/' : process.env.REACT_APP_URLAPI,
  withCredentials: true,
});

export const services = (method, service, body) => {
  switch (method) {
    case "blob":
      let blob = `${service}`;

      return axios
        .get(blob, configBlob())
        .then((r) => {
          return response(r);
        })
        .catch((err) => {
          return response(err.response);
        });
    case "GET":
      let url = `${service}`;

      return axios
        .get(url, config())
        .then((r) => {
          return response(r);
        })
        .catch((err) => {
          return response(err.response);
        });

    case "POST":
      return axios
        .post(`${service}`, body, config())
        .then((r) => {
          return response(r);
        })
        .catch((err) => {
          return response(err.response);
        });

    case "PUT":
      return axios
        .put(`${service}`, body, config())
        .then((r) => {
          return response(r);
        })
        .catch((err) => {
          return response(err.response);
        });

    case "DELETE":
      return axios
        .delete(`${service}`, config())
        .then((r) => {
          return response(r);
        })
        .catch((err) => {
          return response(err.response);
        });

    default:
      break;
  }
};

export const showMessage = (title) => {
  Swal.fire({
    title: title,
    text: "Por favor, inicie sesión de nuevo.",
    confirmButtonColor: "#4a001f",
    confirmButtonText: "Aceptar",
    allowOutsideClick: false,
  }).then(() => {
    localStorage.clear(); document.cookie = 'app_auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.href = "/login";
  });
  return;
}



const response = (r) => {


  if (r === undefined) {
    return false;
  }

  let isLoggingOut = false;

  if (r.status === 401 && !isLoggingOut) {
    isLoggingOut = true;

    showMessage("Tu sesión ha expirado");

    localStorage.clear(); document.cookie = 'app_auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    sessionStorage.clear();
  }

  if (r.status === 200) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 201) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 400) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 421) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 422) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 425) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 429) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 500) {
    return { status: r.status, data: r.data };
  }

  if (r.status === 503) {
    window.location.href = "/mantenimiento";

    return { status: r.status };
  }

  return { status: r.status, errors: r.data.error };
};
